import { useEffect } from 'react'

export default function (handler, ...refs) {
  useEffect(() => {
    const listener = (event) => {
      if (
        refs.find((ref) => ref.current && ref.current.contains(event.target))
      ) {
        return
      }
      handler(event)
    }

    document.addEventListener('mousedown', listener)
    document.addEventListener('touchstart', listener)

    return () => {
      document.removeEventListener('mousedown', listener)
      document.removeEventListener('touchstart', listener)
    }
  }, [refs, handler])
}
